import { breadcrumb } from './breadcrumb';
import { campaign } from './campaign';
import { stats } from './stats';
import { worksheets } from './worksheets';

export const autoinformer = {
  breadcrumb,
  campaign,
  stats,
  worksheets,

  task: {
    status: {
      success: 'Success',
      pending: 'Queue',
      processing: 'Processing',
      fail: 'Fail'
    },

    create: 'Create scheme',

    button: {
      create: 'Add task'
    },

    field: {
      number: 'Number'
    },

    table: {
      field: {
        attempts: 'Attempts',
        last_attempt: 'Last attempt'
      }
    },

    modal: {
      remove: {
        content: `Are you sure you want to delete the task with the number <b>{number}</b>`
      }
    }
  },
  validator: {
    field: {
      calls_limit: {
        max_value: 'Predictive Dialer supports no more than 250 simultaneous connections.'
      },
      date_time_error: 'The date and time must be later than the current in UTC +00:00'
    },
    empty_mediafiles: 'Check the diagram. All "Media file" and "IVR menu" elements on the diagram must contain an audio file'
  }
};
